import qs from 'qs';
import { ENVIRONMENT } from '../constants/constants';

const ENV_HOST = {
  [ENVIRONMENT.DEV]: 'ittz-platform-dev.cn.bg.corpintra.net',
  [ENVIRONMENT.UAT]: 'ittz-platform-uat.cn.bg.corpintra.net',
  [ENVIRONMENT.STAGING]: 'ittz-platform-staging.cn.svc.corpintra.net',
  [ENVIRONMENT.PROD]: 'ittz-tech-platform.cn.svc.corpintra.net',
  [ENVIRONMENT.INTERNET_DEV]: 'idp-auth-itt-dev.mercedes-benz.com.cn',
  [ENVIRONMENT.INTERNET_PROD]: 'idp-auth-itt.mercedes-benz.com.cn'
};

const { hostname: domain, protocol } = window.location;
const mainDomain = Object.values(ENV_HOST).find(item => domain.endsWith(item));

const getMainDomain = () => mainDomain;

const getMainOrigin = () => `${protocol}//${mainDomain}`;

const parseSearch = searchString =>
  qs.parse(searchString, { ignoreQueryPrefix: true });

const getEnvType = () => {
  const env = Object.keys(ENV_HOST).find(key => mainDomain === ENV_HOST[key]);
  return env || ENVIRONMENT.DEV;
};

export { getMainDomain, parseSearch, getMainOrigin, getEnvType };
